import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminEmailAnalytics from "@/pages/admin/AdminEmailAnalytics";

export const Route = createFileRoute("/admin/email-analytics")({
  component: () => (
    <ProtectedRoute>
      <AdminEmailAnalytics />
    </ProtectedRoute>
  ),
});
